/**
 * Property Communications tab – Reports Reminder Frequency only (Angular property-edit).
 * Same main form as Property Info; no separate Save (header Submit).
 */
import { CalendarClock } from 'lucide-react'
import { Controller } from 'react-hook-form'
import { SectionCard } from '@/components/ui/SectionCard'
import tabStyles from '@/features/company/styles/companyInfoTab.module.css'
import { COMM_FIELD_BASE, COMM_LABEL } from '@/lib/styles/companyEditTabShell'
import { cn } from '@/lib/utils/helpers'
import { REPORT_FREQUENCIES, TOOLTIP_REPORTS_FREQUENCY } from '../constants'
import type { PropertyCommunicationsTabProps } from '../types'

const COMM_FIELD = cn(COMM_FIELD_BASE, 'h-10 w-full')

export function PropertyCommunicationsTab({ control, canEdit }: PropertyCommunicationsTabProps) {
  return (
    <div
      data-testid="property-communications-tab"
      className={`${tabStyles.tabContent} animate-in fade-in duration-300`}
    >
      <SectionCard
        icon={CalendarClock}
        title="Reports Reminder Frequency"
        testId="property-communications-reports-section"
        titleTestId="property-communications-reports-section-title"
        infoContent={TOOLTIP_REPORTS_FREQUENCY}
        infoTestId="property-communications-reports-note"
      >
        <div className="w-full max-w-xs sm:max-w-sm">
          <label htmlFor="property-communications-email-frequency" className={COMM_LABEL}>
            Frequency<span className="font-semibold text-[#dc2626]">*</span>
          </label>
          <Controller
            name="email_frequency"
            control={control}
            render={({ field }) => (
              <select
                {...field}
                id="property-communications-email-frequency"
                data-testid="property-communications-frequency-select"
                disabled={!canEdit}
                className={cn(COMM_FIELD, !canEdit && 'cursor-not-allowed opacity-60')}
              >
                <option value="">Select Frequency</option>
                {REPORT_FREQUENCIES.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            )}
          />
        </div>
      </SectionCard>
    </div>
  )
}
